import { useTopBannerDropdownMenu } from './hooks';
import { TopBannerDropdownMenuPresentation } from './presentations';

type TopBanner = {
  id: number;
  title: string;
  transitionUrl: string;
  isActive: boolean;
  sortOrder: number;
  imageUrl: string;
  groupName?: string;
};

type Props = {
  topBanner: TopBanner;
  onSelected: () => void;
};

/**
 * トップバナードロップダウンメニューのコンテナコンポーネント
 */
export const TopBannerDropdownMenu: React.FC<Props> = ({ topBanner, onSelected }) => {
  const {
    actions: { handleSelectEdit, handleSelectToggleStatus, handleSelectDelete },
  } = useTopBannerDropdownMenu({ topBanner, onSelected });

  return (
    <TopBannerDropdownMenuPresentation
      isActive={topBanner.isActive}
      onSelectEdit={handleSelectEdit}
      onSelectToggleStatus={handleSelectToggleStatus}
      onSelectDelete={handleSelectDelete}
    />
  );
};
